import * as z from "zod";
import { recordConnectorUsage, usageRef } from "../connectorUsages";
import { zql } from "../generatedDrizzleSchema";
import { assertSupplierAvailable } from "../rbac/crossResourceAvailability";
import { mutator } from "./mutator";

// Records the user's confirmation that this workflow's build chats may use a
// connector: execute injects its authentication from then on, on every branch.
// Connectors already on a step need no confirmation — a step is the same
// consent. Confirmation is consent, not capability — only space-available
// connectors qualify, and execute re-checks availability at every call, so a
// row whose grants were since revoked is inert.
export const associateBranchChatWithConnectedApp = mutator({
  schema: z.object({
    branchId: z.string(),
    connectedAppId: z.string(),
  }),
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
    {
      permission: "connected_app:use",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, ctx, args: { app, branch } }) => {
    await assertSupplierAvailable({
      tx,
      tenantId: ctx.tenantId,
      ruleId: "space_uses_connected_apps",
      dependentScopeId: branch.workflow.spaceId,
      supplierScopeId: app.id,
    });

    const ref = usageRef.workflowChat(branch.workflowId);
    const [existing] = await tx.run(
      zql.connectedAppUsages
        .where("connectedAppId", app.id)
        .where("type", ref.type)
        .where("refId", ref.refId)
        .where("subKey", ref.subKey)
    );
    if (existing) return;

    await recordConnectorUsage(tx, app.id, ref, ctx.tenantId);
  },
});
